import { combineReducers, Reducer, ReducersMapObject } from "redux";
import { connectRouter } from "connected-react-router";
import { History } from "history";
import IStore from "../models/IStore";
import RequestingReducer from "./requesting/RequestingReducer";
import ErrorReducer from "./error/ErrorReducer";
import ToastsReducer from "./toasts/ToastsReducer";
import MenuReducer from "./menu/MenuReducer";
import ContentsReducer from "./contents/ContentsReducer";
import PreventivoReducer from "./preventivo/PreventivoReducer";
import UserReducer from "./user/UserReducer";
import LookUpReducer from "./lookup/LookUpReducer";
import RichiestaReducer from "./richiesta/RichiestaReducer";
import PraticaReducer from "./pratica/PraticaReducer";
import ConfigurationReducer from "./configuration/ConfigurationReducer";

export default (history: History): Reducer<IStore> => {
    const reducerMap: ReducersMapObject<IStore> = {
        error: ErrorReducer.reducer,
        requesting: RequestingReducer.reducer,
        router: connectRouter(history) as any,
        toasts: new ToastsReducer().reducer,
        menu: new MenuReducer().reducer,
        contents: new ContentsReducer().reducer,
        user: new UserReducer().reducer,
        preventivo: new PreventivoReducer().reducer,
        richiesta: new RichiestaReducer().reducer,
        lookups: new LookUpReducer().reducer,
        pratica: new PraticaReducer().reducer,
        configuration: new ConfigurationReducer().reducer,
    };

    return combineReducers(reducerMap);
};
